__turbopack_context__.v({
  "blok-big-title": "ColumnBlok-module__Du0sua__blok-big-title",
  "blok-subtitle": "ColumnBlok-module__Du0sua__blok-subtitle",
  "blok-title": "ColumnBlok-module__Du0sua__blok-title",
  "root": "ColumnBlok-module__Du0sua__root",
});
